
/* D'BRANDED - Colour-specific collection cards */

function updateColourVariantCards() {
  document.querySelectorAll(
    '.product-grid__item[data-colour-variant-id]'
  ).forEach((tile) => {
    const variantId = tile.dataset.colourVariantId;
    const heroSrc = tile.dataset.colourHeroSrc;
    const hoverSrc = tile.dataset.colourHoverSrc;

    if (!variantId) return;

    // Keep product links pointing to the correct colour.
    tile.querySelectorAll(
      'a.product-card__link, .card-gallery a.contents'
    ).forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.href = url.toString();
    });

    const gallery = tile.querySelector('.card-gallery');
    if (!gallery) return;

    // Apply the correct colour-specific hero image.
    if (heroSrc) {
      const firstSlide = gallery.querySelector('slideshow-slide');
      const image = firstSlide
        ? firstSlide.querySelector('img')
        : gallery.querySelector('img');

      if (image) {
        // Prevent responsive sources overriding the hero.
        const picture = image.closest('picture');

        if (picture) {
          picture.querySelectorAll('source').forEach(
            (source) => source.remove()
          );
        }

        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = heroSrc;

        tile.classList.add('dbranded-hero-ready');
      }
    }

    // Add the correct colour-specific hover image.
    if (hoverSrc) {
      const galleryLink = gallery.querySelector('a.contents');

      if (
        galleryLink &&
        !galleryLink.querySelector('.dbranded-colour-hover')
      ) {
        const overlay = document.createElement('img');

        overlay.src = hoverSrc;
        overlay.alt = '';
        overlay.className = 'dbranded-colour-hover';
        overlay.loading = 'lazy';
        overlay.decoding = 'async';

        galleryLink.appendChild(overlay);
        gallery.classList.add('dbranded-has-colour-hover');
      }
    }
  });
}

// Run when the page first loads.
if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    updateColourVariantCards
  );
} else {
  updateColourVariantCards();
}

/* D'BRANDED - Restore images after collection filtering */

let dbrandedFilterCheckRunning = false;

function checkDbrandedColourImages() {
  const unreadyTiles = document.querySelectorAll(
    '.product-grid__item[data-colour-hero-src]:not(.dbranded-hero-ready)'
  );

  if (unreadyTiles.length > 0) {
    updateColourVariantCards();
  }
}

function startDbrandedFilterCheck() {
  if (dbrandedFilterCheckRunning) return;

  dbrandedFilterCheckRunning = true;

  // Check for filtered products while the collection is open.
  setInterval(checkDbrandedColourImages, 300);

  // Apply images immediately when possible.
  checkDbrandedColourImages();
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    startDbrandedFilterCheck
  );
} else {
  startDbrandedFilterCheck();
}
